import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=baa4f79e&scoped=true"
import script from "./Loja.vue?vue&type=script&lang=js"
export * from "./Loja.vue?vue&type=script&lang=js"
import style0 from "./Loja.vue?vue&type=style&index=0&id=baa4f79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa4f79e",
  null
  
)

export default component.exports